import { useEffect, useRef, useState } from 'react';

function loadJson(key) {
  try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; }
}

// MC56 (03/09/2026): `pieceType` é o tipo da PEÇA ATIVA de verdade (ex.:
// "Contestação (Cível)"), resolvido pelo chamador a partir de
// activeWorkspace.pieces[].pieceType — nunca de activeWorkspace.pieceType
// sozinho, que é um campo de nível de CADERNO (legado, sempre a 1ª peça
// criada, de antes de existir "Nova Peça"). Sem essa distinção, trocar de
// peça dentro do mesmo caderno nunca reavaliava o template — a 2ª peça
// (e qualquer peça depois dela) ficava presa ao template da 1ª.
export function useFileHubChecklist(activeWorkspace, pieceType) {
  const resolveTemplateKey = (t) =>
    String(t || '').trim() || 'Petição Inicial (Cível)';

  const [checklist, setChecklist] = useState(() => {
    const t = resolveTemplateKey(pieceType || activeWorkspace?.pieceType);
    const saved = loadJson(`rda_chk_template_${t}`);
    if (Array.isArray(saved) && saved.length) return saved;
    return [];
  });
  const [editingPieceType, setEditingPieceType] = useState(false);
  const [draftPieceType, setDraftPieceType] = useState('');

  // Reavalia sempre que a peça ATIVA muda de tipo — o useState acima só
  // roda na 1ª montagem do hook, e o hook em si não desmonta ao trocar de
  // peça (mesmo componente FileHubArea, só activePieceId muda).
  const lastPieceTypeRef = useRef(pieceType);
  useEffect(() => {
    if (pieceType === lastPieceTypeRef.current) return;
    lastPieceTypeRef.current = pieceType;
    const t = resolveTemplateKey(pieceType || activeWorkspace?.pieceType);
    const saved = loadJson(`rda_chk_template_${t}`);
    setChecklist(Array.isArray(saved) && saved.length ? saved : []);
  }, [pieceType, activeWorkspace?.pieceType]);

  return {
    checklist, setChecklist,
    editingPieceType, setEditingPieceType,
    draftPieceType, setDraftPieceType,
  };
}
